module.exports = __webpack_public_path__ + "Helvetica.0de46700c74f192af774.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/minha-jnnet/src/app/@theme/fontes/Helvetica/Helvetica.svg
// module id = ../../../../../src/app/@theme/fontes/Helvetica/Helvetica.svg
// module chunks = styles